import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import * as styles from "../MeterReadingsPage.styles";

const NotEnabledCard = () => {
  const { t } = useTranslation(["common", "meterReadings"]);

  return (
    <div className={styles.card}>
      <h2 className={styles.cardTitle}>{t("meterReadings:notEnabled.title")}</h2>
      <p className={styles.cardDescription}>{t("meterReadings:notEnabled.description")}</p>
      <div className={styles.formActions}>
        <Link to="/addresses" className={styles.saveButton}>
          {t("meterReadings:notEnabled.link")}
        </Link>
      </div>
    </div>
  );
};

export default NotEnabledCard;
